export const DIRECTION_TOP = 'top';
export const DIRECTION_BOTTOM = 'bottom';
export const DIRECTION_LEFT = 'left';
export const DIRECTION_RIGHT = 'left';
